import { createRef, Ref } from 'lit/directives/ref.js';
import { useState } from './use-state.js';

export function useRef<T = Element>(): Ref<T> {
  const [elementRef] = useState(createRef<T>());
  return elementRef;
}
